import Spinner from '@/components/common/Spinner/Spinner';
import { SODetails } from '../../hooks/useGetSODetails';
import styles from './detail-container.module.scss';
import { SalesOrderDetailsCard } from './SalesOrderDetailsCard';

interface DetailsListProps {
  isLoading: boolean;
  details: SODetails;
}

export function DetailContainer({ isLoading, details }: DetailsListProps) {
  if (isLoading) {
    return (
      <div className={styles['no-content']}>
        <Spinner />
      </div>
    );
  }

  return (
    <>
      {!details && <div className={styles['no-content']}>Nothing to show</div>}

      {details && <SalesOrderDetailsCard details={details} />}
    </>
  );
}
